import { render } from "./ClassCredDetails.vue?vue&type=template&id=3812581e"
import script from "./ClassCredDetails.vue?vue&type=script&lang=js"
export * from "./ClassCredDetails.vue?vue&type=script&lang=js"

import "./ClassCredDetails.vue?vue&type=style&index=0&id=3812581e&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__